



















































import { Component, Vue } from 'vue-property-decorator';
import { updateHtmlLang } from '@/plugins/i18n';

interface Language {
  code: string;
  name: string;
}

@Component
export default class NavbarLanguageSelector extends Vue {
  menuOpen = false;

  get languages(): Language[] {
    return [
      { code: 'en', name: 'English' },
      { code: 'es', name: 'Español' },
      { code: 'fr', name: 'Français' },
      { code: 'de', name: 'Deutsch' },
      { code: 'it', name: 'Italiano' }
    ];
  }

  get currentLanguageCode(): string {
    return this.$i18n.locale.toUpperCase();
  }

  selectLanguage(languageCode: string) {
    // Store in localStorage first
    localStorage.setItem('planbook-locale', languageCode);

    // Then update VueI18n
    this.$i18n.locale = languageCode;

    // Update HTML lang attribute
    updateHtmlLang(languageCode);

    this.menuOpen = false;
  }
}
